import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobeCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: "globe-check",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.92041 5.8C5.65625 3.49852 8.40401 2 11.5 2C15.9953 2 19.7748 5.144 20.7536 9.34707C20.0969 9.13914 19.4017 9.01949 18.682 9.00219C17.9636 6.92998 16.3748 5.27113 14.35 4.45479V4.85C14.35 5.89975 13.4998 6.75 12.45 6.75H10.55V8.65C10.55 9.1744 10.1244 9.6 9.6 9.6H8.65V11.5H12.9186C11.7267 12.8287 11 14.5825 11 16.5C11 18.1637 11.5471 19.7042 12.4704 20.9507C12.1513 20.9833 11.8275 21 11.5 21C6.26455 21 2 16.7355 2 11.5C2 9.37237 2.71246 7.41186 3.9 5.82598V5.8H3.92041ZM5.8 11.5L4.09668 9.79668C3.97175 10.3448 3.9 10.9131 3.9 11.5C3.9 15.3861 6.79348 18.5691 10.55 19.0351V17.2C9.50025 17.2 8.65 16.3498 8.65 15.3V14.35L5.8 11.5Z",
		fill: "#1237B5"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.5 11C15.475 11 13 13.475 13 16.5C13 19.525 15.475 22 18.5 22C21.525 22 24 19.525 24 16.5C24 13.475 21.525 11 18.5 11ZM21.0674 14.0257L22.3493 15.3076L18.0417 19.617L15.109 16.6826L16.391 15.4007L18.0417 17.0496L21.0674 14.0257Z",
		fill: "#00C670"
	})]
});
export default SvgGlobeCheck;
